declare var $: any;

export class EstimateApi {
    async update(id: number, state: string) {
        await fetch(`/api/estimates/${id}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            body: JSON.stringify({
                state: state,
            }),
        });
    }
}
